import { useContext } from "react";
import { partition, sortBy } from "lodash";
import { useGetCustomMapsForSettingsQuery } from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Buttons/Button";
import Divider from "../../../Common/Divider";
import { Header, HeaderTitle } from "../../__styles__/Content";
import { ContentWrapper } from "./__styles__/MapObjects";
import MapObjectsGrid from "./MapObjectsGrid";
import { useUpsertCustomMapModal } from "./UpsertCustomMapModal";
import { useUpsertGeomCustomMapModal } from "./UpsertGeomCustomMapModal";
import { useDeleteCustomMapModal } from "./useDeleteCustomMapWithConfirmation";

const MapObjects = () => {
  const { admin } = useContext(AuthContext);
  const { data, loading, refetch } = useGetCustomMapsForSettingsQuery();

  const [showUpsertModal] = useUpsertCustomMapModal({
    onSave: () => void refetch(),
  });
  const showDeleteModal = useDeleteCustomMapModal({
    onDelete: () => void refetch(),
  });
  const [showUpsertGeomCustomMapModal] = useUpsertGeomCustomMapModal({
    onSave: () => void refetch(),
  });

  const [objectCustomMaps, nonObjectCustomMaps] = partition(
    sortBy(data?.account?.customMaps ?? [], "name"),
    map => map.isObject,
  );

  return (
    <Box>
      <Header accountSettings>
        <HeaderTitle accountSettings>Map objects</HeaderTitle>
        {admin && (
          <Button
            variant="outline"
            size="small"
            iconStart="plus"
            onPress={() => showUpsertModal()}
            title="Add"
          />
        )}
      </Header>

      <ContentWrapper>
        {loading ?
          <div>Loading...</div>
        : <MapObjectsGrid
            isObject={true}
            customMaps={objectCustomMaps}
            showEditModal={showUpsertModal}
            showDeleteModal={showDeleteModal}
          />
        }
      </ContentWrapper>
      <Divider />
      <Header accountSettings>
        <HeaderTitle accountSettings>Non-object maps</HeaderTitle>
        {admin && (
          <Button
            variant="outline"
            size="small"
            iconStart="plus"
            onPress={() => showUpsertGeomCustomMapModal()}
            title="Add"
          />
        )}
      </Header>

      <ContentWrapper>
        {loading ?
          <div>Loading...</div>
        : <MapObjectsGrid
            isObject={false}
            customMaps={nonObjectCustomMaps}
            showEditModal={showUpsertGeomCustomMapModal}
            showDeleteModal={showDeleteModal}
          />
        }
      </ContentWrapper>
    </Box>
  );
};

export default MapObjects;
